// components/FileManager.js
import React, {useState, useEffect} from "react";
import axios from "axios";
import {
    Table,
    Button,
    Input,
    FormGroup,
    Label,
    Form,
    Progress,
    Container,
    Row,
    Card,
    CardHeader,
    CardFooter, Pagination, PaginationItem, PaginationLink, CardBody
} from "reactstrap";
import Header from "../../components/Headers/Header";
import {getCookie} from "tools/tools"
import FileModal from "../../components/Modals/FileModal";
import {useTranslation} from "react-i18next";

const FileManager = ({calculationId}) => {
    const [files, setFiles] = useState([]);
    const [fileToUpload, setFileToUpload] = useState(null);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchFiles();
    }, [calculationId]);

    const fetchFiles = (page) => {
        const params = {
            page,
            page_size: 10,
        };
        axios.get(`/api/files/`, {params})
            .then(response => {
                setFiles(response.data.results);
                setTotalPages(Math.ceil(response.data.count / 10));
            })
            .catch(error => console.error("Error fetching files:", error));
    };

    const handleFileChange = (e) => {
        setFileToUpload(e.target.files[0]);
    };

    useEffect(() => {
        fetchFiles(currentPage);
    }, [currentPage]);


    const onFileUpload = async () => {
        const formData = new FormData();
        formData.append('file', fileToUpload);

        try {
            setUploading(true);
            const response = await axios.post('/api/files/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                withCredentials: true,
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor((loaded * 100) / total);
                    setUploadPercentage(percent);
                }
            });
            setFileToUpload(null);
            console.log(response.data);
            alert('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('Error uploading file');
        } finally {
            setUploading(false);
            setUploadPercentage(0);
        }
    };


    const deleteFile = (fileId) => {
        axios.delete(`/api/files/${fileId}/delete_file/`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-CSRFToken': getCookie('csrftoken')
            },
            withCredentials: true
        })
            .then(() => fetchFiles())
            .catch(error => console.error("Error deleting file:", error));
    };

    const { t, i18n } = useTranslation();

    return (
        <>
            <Header/>
            <Container className="mt--7" fluid>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardBody>
                                <Form inline>
                                    <FormGroup>
                                        <Label for="file" className="mr-sm-2">{t('File')}</Label>
                                        <Input type="file" name="file" id="file" onChange={handleFileChange}/>
                                    </FormGroup>
                                    <Button onClick={onFileUpload}>{t('Upload')}</Button>
                                </Form>
                            </CardBody>
                            {uploading && (
                                <Progress value={uploadPercentage} className="mb-3">
                                    {uploadPercentage}%
                                </Progress>
                            )}

                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                <tr>
                                    <th scope="col">File Name</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {files.map(file => {
                                    if (file.file){
                                        const name = file.file.split('/').pop();
                                        return (
                                            <tr key={file.id}>
                                                <td><a href={file.file}>{name}</a></td>
                                                <td>
                                                    <Button color="danger"
                                                            onClick={() => deleteFile(file.id)}>Delete</Button>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })
                                }
                                </tbody>
                            </Table>
                            <CardFooter className="py-4">
                                <nav aria-label="...">
                                    <Pagination className="pagination justify-content-end mb-0">
                                        <PaginationItem disabled={currentPage === 1}>
                                            <PaginationLink
                                                href="#pablo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (currentPage > 1) setCurrentPage(currentPage - 1);
                                                }}
                                                tabIndex="-1"
                                            >
                                                <i className="fas fa-angle-left"/>
                                                <span className="sr-only">Previous</span>
                                            </PaginationLink>
                                        </PaginationItem>
                                        {[...Array(totalPages).keys()].map(page => (
                                            <PaginationItem key={page + 1} active={page + 1 === currentPage}>
                                                <PaginationLink
                                                    href="#pablo"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setCurrentPage(page + 1);
                                                    }}
                                                >
                                                    {page + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        ))}
                                        <PaginationItem disabled={currentPage === totalPages}>
                                            <PaginationLink
                                                href="#pablo"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                                                }}
                                            >
                                                <i className="fas fa-angle-right"/>
                                                <span className="sr-only">Next</span>
                                            </PaginationLink>
                                        </PaginationItem>
                                    </Pagination>
                                </nav>
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default FileManager;